import { api } from '../../../shared/services/api';

/**
 * DockerService
 * Frontend service for Docker API calls
 */
class DockerService {
  /**
   * Get all containers
   * @param {boolean} all - Include stopped containers
   * @returns {Promise<Object>}
   */
  async getContainers(all = true) {
    return await api.get(`/api/docker/containers?all=${all}`);
  }

  /**
   * Get container details
   * @param {string} containerId - Container ID
   * @returns {Promise<Object>}
   */
  async getContainerDetails(containerId) {
    return await api.get(`/api/docker/containers/${containerId}`);
  }

  /**
   * Get container stats
   * @param {string} containerId - Container ID
   * @returns {Promise<Object>}
   */
  async getContainerStats(containerId) {
    return await api.get(`/api/docker/containers/${containerId}/stats`);
  }

  /**
   * Get container logs
   * @param {string} containerId - Container ID
   * @param {number} tail - Number of lines to retrieve
   * @returns {Promise<Object>}
   */
  async getContainerLogs(containerId, tail = 100) {
    return await api.get(`/api/docker/containers/${containerId}/logs?tail=${tail}`);
  }

  /**
   * Start a container
   * @param {string} containerId - Container ID
   * @returns {Promise<Object>}
   */
  async startContainer(containerId) {
    return await api.post(`/api/docker/containers/${containerId}/start`, {});
  }

  /**
   * Stop a container
   * @param {string} containerId - Container ID
   * @returns {Promise<Object>}
   */
  async stopContainer(containerId) {
    return await api.post(`/api/docker/containers/${containerId}/stop`, {});
  }

  /**
   * Restart a container
   * @param {string} containerId - Container ID
   * @returns {Promise<Object>}
   */
  async restartContainer(containerId) {
    return await api.post(`/api/docker/containers/${containerId}/restart`, {});
  }

  /**
   * Pause a container
   * @param {string} containerId - Container ID
   * @returns {Promise<Object>}
   */
  async pauseContainer(containerId) {
    return await api.post(`/api/docker/containers/${containerId}/pause`, {});
  }

  /**
   * Unpause a container
   * @param {string} containerId - Container ID
   * @returns {Promise<Object>}
   */
  async unpauseContainer(containerId) {
    return await api.post(`/api/docker/containers/${containerId}/unpause`, {});
  }
}

export const dockerService = new DockerService();
